import DownloadApp from './DownloadApp'

export default DownloadApp
